module.exports = __webpack_public_path__ + "static/img/mode4-2.61e87695.png";